import React from "react";
import { Formik } from "formik";
import { withStyles, FormControl, FormGroup, Checkbox, FormControlLabel } from "@material-ui/core";
import * as Yup from "yup";
import { KeyboardDatePicker } from '@material-ui/pickers';
import moment from 'moment';
import {getDateFormat} from "../../../sc-utilities/date";

const styles = theme => ({

    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    helperText: {
        marginTop: '4px'
    },
    cancel: {
        width: "200px",
        marginRight: '4%'

    },
    formGroup: {
        width: "200px",
        display: 'contents',
        marginRight: '4%'

    },
    checkbox: {
        marginTop: '2%'

    },
    formControl: {
        display: 'inline-block',
        width: "680px"
    },
    typography: {
        marginTop: '5px'
    },
    icon: {
        margin: theme.spacing(2)
    }

});

const DataRangeForm = props => {
    const { classes, formSettings, print, value, initialValues, handleSubmit, translations, filterDataRange, setValue, filterDataMyErasure, hideOptions } = props;


    return (
        <div >
            <Formik
                initialValues={initialValues}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(true);
                    handleSubmit(values);
                    setSubmitting(false);
                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, handleBlur, handleSubmit, setFieldValue, handleChange } = formikProps;

                    const filter = (name, date) => {
                        setFieldValue(name, date)
                        values[name] = date
                        filterDataRange(values)
                        values.From.set({
                            hours: 0,
                            minutes: 0,
                            seconds: 0
                        })
                        values.To.set({
                            hours: 23,
                            minutes: 59,
                            seconds: 59
                        })
                        setValue({ From: values.From, To: values.To, ShowOnlyMyErasures: value.ShowOnlyMyErasures })
                    }
                    const showOnlyMy = (event) => {
                        setValue({ From: value.From, To: value.To, ShowOnlyMyErasures: event.target.checked })
                        filterDataMyErasure(event.target.checked)
                    }

                    return (
                        <form onSubmit={handleSubmit}>
                            <FormControl className={classes.formControl} margin={'dense'}>
                                <KeyboardDatePicker
                                    clearable
                                    name={'From'}
                                    onBlur={handleBlur}
                                    allowKeyboardControl={false}
                                    error={!!(errors.From && touched.From)}
                                    maxDate={values.To}
                                    onChange={(date) =>
                                        filter('From', date)
                                    }
                                    value={values.From !== "" ? values.From : null}
                                    margin={"dense"}
                                    emptyLabel={translations['select_from'] || 'Please select date from'}
                                    label={translations['select_from'] || 'Please select date from'}
                                    className={classes.cancel}
                                    // onAccept={date => filter('From' , date)}
                                    fullWidth={true}
                                    format={getDateFormat()}
                                />
                                <KeyboardDatePicker
                                    clearable
                                    name={'To'}
                                    className={classes.cancel}
                                    onBlur={handleBlur}
                                    maxDate={moment()}
                                    allowKeyboardControl={false}
                                    emptyLabel={translations['select_to'] || 'Please select date to'}
                                    label={translations['select_to'] || 'Please select date to'}
                                    error={!!(errors.To && touched.To)}
                                    onChange={(date) =>
                                        filter('To', date)
                                    }
                                    value={values.To !== "" ? values.To : null}
                                    margin={"dense"}
                                    fullWidth={true}
                                    format={getDateFormat()}
                                />
                                {!print && !hideOptions ?
                                    <FormGroup className={classes.formGroup}>
                                        <FormControlLabel
                                            className={classes.checkbox}
                                            control={
                                                <Checkbox
                                                    color={'primary'}
                                                    margin={"dense"}
                                                    name={"ShowOnlyMyErasures"}
                                                    checked={values.ShowOnlyMyErasures || false}
                                                    onChange={handleChange}
                                                    onClick={(event) => showOnlyMy(event)}
                                                />
                                            }
                                            label={`${translations['show_only_my_erasures'] || 'Show only my erasures'}`}
                                        />
                                    </FormGroup> : null}
                            </FormControl>
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(DataRangeForm);
